'use strict';
var ClinicalPracticeToolsController = /** @class */ (function () {
    /*@ngInject*/
    function ClinicalPracticeToolsController($scope, EducationSubNavService) {
        $scope.$ctrl.value.selectedpageindex = 5;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
    }
    return ClinicalPracticeToolsController;
}());
export default ClinicalPracticeToolsController;
//# sourceMappingURL=clinical-practice-tools.controller.js.map